import { render, staticRenderFns } from "./GiveProduct.vue?vue&type=template&id=ee2b0c52&scoped=true"
import script from "./GiveProduct.vue?vue&type=script&lang=js"
export * from "./GiveProduct.vue?vue&type=script&lang=js"
import style0 from "./GiveProduct.vue?vue&type=style&index=0&id=ee2b0c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2b0c52",
  null
  
)

export default component.exports